export const transform = (inputArray, valueKey) => {
  return inputArray.reduce((map, obj) => {
    map[obj.code] = obj[valueKey];
    return map;
  }, {});
};

export const transformCountryList = countryList => {
  return countryList.map(country => ({
    ...country,
    id: country.code,
    name: `(${country.dialCode}) ${country.name}`,
    countryName: country.name,
  }));
};

export const transformLanguageList = languages =>
  languages.map(language => ({
    id: language.code,
    ...language,
  }));

export const transformTimezone = input => {
  return input.map(item => ({
    ...item,
    id: item.name,
    name: item.text_en,
  }));
};

export const convertToDecimal = (num, currencySymbol) => {
  // check if num is not a number
  if (isNaN(num)) {
    // check if the string has dollar sign
    if (num.indexOf(currencySymbol) >= 0) {
      //strip dollar
      const dollar = parseFloat(num.replace(currencySymbol, ''));
      return roundToNearestTwo(dollar);
    } else {
      const dollar = parseFloat(num);
      return roundToNearestTwo(dollar);
    }
  } else {
    // if it is a number then return as usual
    return roundToNearestTwo(num);
  }
};

const roundToNearestTwo = num => {
  return (Math.round(num * 100) / 100).toFixed(2);
};

export const convertCentsToDollars = cents => {
  const dollars = cents / 100;
  const dollarsWithDecimal = convertToDecimal(dollars);
  return dollarsWithDecimal;
};
